import { ElInfiniteScroll } from '@pit-element-plus/components/infinite-scroll'
import { ElLoading } from '@pit-element-plus/components/loading'
import { ElMessage } from '@pit-element-plus/components/message'
import { ElMessageBox } from '@pit-element-plus/components/message-box'
import { ElNotification } from '@pit-element-plus/components/notification'
import { ElPopoverDirective } from '@pit-element-plus/components/popover'

import type { Plugin } from 'vue'

export default [
  ElInfiniteScroll,
  ElLoading,
  ElMessage,
  ElMessageBox,
  ElNotification,
  ElPopoverDirective,
] as Plugin[]
